import { render, staticRenderFns } from "./EmployeeDetailConfiguration.vue?vue&type=template&id=38451f00&"
import script from "./EmployeeDetailConfiguration.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetailConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports